import { render, staticRenderFns } from "./CompareSimulationsColumn.vue?vue&type=template&id=0f9fe76c&"
import script from "./CompareSimulationsColumn.vue?vue&type=script&lang=js&"
export * from "./CompareSimulationsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports